<template>
	<modal :show.sync=show modalClasses="large-sized-modal" :hide-footer="true">
		<h3 slot="header" class="mb-0 font-weight-500">Update Role Access</h3>
		<ValidationObserver v-slot="{ invalid }" ref="observer">
			<b-form @submit.prevent="submit" ref="updateRoleAccessForm">
				<b-row>
					<!-- FIELD ROLE NAME -->
					<b-col cols="12">
						<b-form-group label="Role Name:">
							<ValidationProvider v-slot="{ errors }" :rules="{ required: true }" :vid="'roleName'">
								<b-form-input v-model="data_form.role_name" type="text" required></b-form-input>
								<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
							</ValidationProvider>
						</b-form-group>
					</b-col>
					<!-- FIELD ROLE TYPE -->
					<b-col cols="12">
						<b-form-group label="Role Group Type:">
							<ValidationProvider v-slot="{ errors }" :rules="{ required: true }" :vid="'roleType'">
								<el-select v-model="data_form.role_type" placeholder="Select">
									<el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value">
									</el-option>
								</el-select>
								<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
							</ValidationProvider>
						</b-form-group>
					</b-col>
					<!-- FIELD ROLE DESCRIPTION -->
					<b-col cols="12">
						<b-form-group label="Description:">
							<b-form-textarea id="textarea" v-model="data_form.role_description" placeholder="Role Description" rows="3"
								max-rows="5"></b-form-textarea>
						</b-form-group>
					</b-col>
					<b-col cols="12">
						<b-form-group label="Access:">
							<el-collapse>
								<el-collapse-item v-for="(mGroup,idx) in available_group_access" :name="`collapse-${mGroup.group_code}`">
									<template slot="title">
										<el-checkbox :indeterminate="data_form.role_access[idx].isIndeterminate" v-model="data_form.role_access[idx].checkAll" @change="handleCheckAll($event,idx)">{{ mGroup.group_name }}</el-checkbox>
									</template>
									<el-checkbox-group v-model="data_form.role_access[idx].selectedItems" @change="handleCheckItem($event,idx)">
										<b-row>
											<b-col cols="3"  v-for="aItem in mGroup.group_access" >
												<el-checkbox :label="aItem.access_code" :name="`item-${mGroup.group_code}`" :id="aItem.access_code">{{ aItem.label }}</el-checkbox>
											</b-col>
										</b-row>
									</el-checkbox-group>
								</el-collapse-item>
							</el-collapse>
						</b-form-group>
					</b-col>

					<b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
						<b-button variant="primary" type="submit" class="w-100" :disabled="invalid">Update</b-button>
					</b-col>
				</b-row>
			</b-form>
		</ValidationObserver>
	</modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Select, Option, CheckboxGroup, Checkbox, Collapse, CollapseItem } from 'element-ui'
import {
	notifyFunctionMixin,
	helperFunctionMixin,
	axios,
	services,
	getHeader
} from '@/assets/js/httpImports.js'
import mainEventBus from '@/assets/js/mainEventBus.js'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import '@/assets/js/formValidations.js'
import _ from 'lodash'

export default {
	props: {
		update_role_access: Boolean,
		role_item: {
			type: Object
		},
		available_group_access: Array
	},
	mixins: [
		notifyFunctionMixin,
		helperFunctionMixin
	],
	components: {
		Modal,
		ValidationObserver,
		ValidationProvider,
		[Select.name]: Select,
		[Option.name]: Option,
		[CheckboxGroup.name]: CheckboxGroup,
		[Checkbox.name]: Checkbox,
		[Collapse.name]: Collapse,
		[CollapseItem.name]: CollapseItem,
	},
	computed: {
		show: {
			get() {
				return this.update_role_access;
			},
			set(newVal) {
				this.$emit('update:update_role_access', newVal);
			},
		},
	},
	data() {
		return {
			data_form: {
				role_id: '',
				role_name: '',
				role_type: '',
				role_description: '',
				role_access: [],
			},
			typeOptions: [
				{
					value: 'director',
					label: 'Director',
				},
				{
					value: 'manager',
					label: 'Manager',
				},
				{
					value: 'sales',
					label: 'Sales',
				},
				{
					value: 'agent',
					label: 'Agent',
				}
			]
		}
	},
	async created() {
		// this.getAvailableAccess();
		this.$watch(
			() => this.role_item,
			(newVal) => {
				if (newVal) {
					this.data_form.role_id = newVal.role_id ?? '';
					this.data_form.role_name = newVal.role_name ?? '';
					this.data_form.role_type = newVal.role_type ?? '';
					this.data_form.role_description = newVal.role_description ?? '';
					this.setCheckbox(newVal.role_access ?? []);
				}
			},
			{ immediate: true }
		)
		
	},
	methods: {
		setCheckbox(currentAccess=[]){
			this.data_form.role_access = [];
			if(this.available_group_access){
				for (let i = 0; i < this.available_group_access.length; i++) {
					const el = this.available_group_access[i];
					let mapAccess = _.map(el.group_access,(o)=>{ return o.access_code });
					let intersect = _.intersection(mapAccess,currentAccess);
				
					let item = {
						checkAll: ((intersect.length > 0) && (intersect.length == mapAccess.length)),
						selectedItems: intersect,
						availableItems: mapAccess,
						isIndeterminate: ((intersect.length > 0) && (intersect.length != mapAccess.length))
					}

					this.data_form.role_access.push(item);
				}
			}
		},
		handleCheckAll(e, idx){
			const group = this.available_group_access[idx];
			this.data_form.role_access[idx].isIndeterminate = false;
			if(e){
				let mapAccess = _.map(group.group_access,(o)=>{ return o.access_code });
				this.data_form.role_access[idx].selectedItems = mapAccess;
				this.data_form.role_access[idx].checkAll = true;
			}else{
				this.data_form.role_access[idx].selectedItems = [];
				this.data_form.role_access[idx].checkAll = false;
			}
			
		},
		handleCheckItem(e, idx){
			let selected = this.data_form.role_access[idx].selectedItems;
			let available = this.data_form.role_access[idx].availableItems;
		
			this.data_form.role_access[idx].checkAll = ((selected.length > 0) && (selected.length == available.length));
			this.data_form.role_access[idx].isIndeterminate = ((selected.length > 0) && (selected.length != available.length));
		},
		getAvailableAccess() {
			axios.get(services.access_control + 'available_access_code', { headers: getHeader() })
				.then(res => {
					this.available_group_access = res.data.data
				})
				.catch(e => {
					this.errorFunction(e)
				})
		},
		submit() {
			const formData = {
					role_name: this.data_form.role_name,
					role_type: this.data_form.role_type,
					role_description: this.data_form.role_description,
					role_access: _.flattenDeep(_.map(this.data_form.role_access,(o)=>{ return o.selectedItems}))
			}
			
			axios.put(services.access_control + 'role/' + this.data_form.role_id, formData, { headers: getHeader() })
				.then(res => {
					this.notifySuccess('<b>Role Access: ' + res.data.message + '</b> - Successfully Updated.')
					this.$emit('closeModal', false)
					mainEventBus.$emit('refresh-status')
					this.resetFormToNull(this.data_form,['role_access'])
					// this.getAvailableAccess()
					this.setCheckbox([])
				})
				.catch(e => {
					this.errorFunction(e)
				})
		},
	}
}
</script>